// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-payment_stripe-sepa',
    // #endregion
    // #region Properties
    props: {
        gateway: {
            type: Object,
            required: true,
            default: {}
        },
        method: {
            type: Object,
            required: true,
            default: {}
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        paymentErrors: '',
        bankName: '',
        kontoOwner: '',
        kontoEMail: '',
        _gateway: {},
        _iban: {},
    }),
    // #endregion
    // #region Mount
    beforeMount() {
        //Bus
        this.$appHost.eventBus.on('checkout-before-commit', this.CreatePaymentMethod);
        //Gateway
        this._gateway = this.$appHost.provider.get('PAYMENT', this.gateway.clientType);
        //Init
        this._gateway.initialize(this.gateway)
            .then(e => {
            this._gateway.createElement('iban', this.method.element)
                .then(f => {
                //Set
                this._iban = f;
                //Mount
                this._iban.mount(this.$refs.iban_element);
                //Errors
                this._iban.addEventListener('change', this.onPaymentChange);
            });
        });
    },
    beforeUnmount() {
        this.$appHost.eventBus.off('checkout-before-commit', this.CreatePaymentMethod);
    },
    // #endregion
    // #region Core
    methods: {
        async CreatePaymentMethod(args) {
            // #region Core
            try {
                //Run
                let tResult = await this._gateway.api.createPaymentMethod({
                    type: 'sepa_debit',
                    sepa_debit: this._iban,
                    billing_details: {
                        name: this.kontoOwner,
                        email: this.kontoEMail
                    }
                });
                if (tResult.error) {
                    this.paymentErrors = tResult.error.message;
                    args.cancel = true;
                }
                else {
                    args.data.payment.details = {
                        paymentID: tResult.paymentMethod.id
                    };
                }
            }
            // #endregion
            // #region Error
            catch (error) {
                this.paymentErrors = error;
                args.cancel = true;
            }
            // #endregion
        },
        onPaymentChange(event) {
            if (event.error) {
                this.paymentErrors = event.error.message;
            }
            else {
                this.paymentErrors = '';
            }
            if (event.bankName) {
                this.bankName = event.bankName;
            }
            else {
                this.bankName = '';
            }
        },
    },
    // #endregion
});
// #endregion
